module.exports = __webpack_public_path__ + "media/images/logo_text_en-39928071b1e67f3bb0d8740756cf6585.svg";